import pub from './../public';
const type = pub.getLang();

const language = {
  'zh-hk': {
    title: '銀行付款資料',
    bankName1: '中銀香港',
    bankName2: '恒生銀行',
    bankName3: '滙豐銀行',
    bankName4: ' FPS轉數快系統識別碼',
    bankAccount: '戶口號碼',
    bankAccountName: '戶口名稱',
    code: '代碼'
  },
  'zh-cn': {
    title: '银行付款资料',
    bankName1: '中银香港',
    bankName2: '恒生银行',
    bankName3: '汇丰银行',
    bankName4:'FPS转数快系統识别码',
    bankAccount: '户口号码',
    bankAccountName: '户口名称',
    code: '代码'
  },
  'en-us': {
    title: 'Bank payment information',
    bankName1: 'BOC Hong Kong',
    bankName2: 'Hang Seng Bank',
    bankName3: 'HSBC',
    bankName4:'FPS ID',
    bankAccount: 'Bank account no.',
    bankAccountName: 'Bank account name',
    code: 'Bank Code'
  }
};
export default language[type];

//地产代理会员专用的楼盘管理系统(PMS) 再次登入
